export enum CONTRACT_TYPE {
  executor = 'executor',
  agent = 'agent',
}

export enum WEBHOOK_API_AUTH_TYPE {
  none = 'NONE',
  basic = 'BASIC',
}

export enum GEO_POINT_TRACKING_TYPE {
  REQUIRED = 'REQUIRED',
  DISABLED = 'DISABLED',
  OPTIONAL = 'OPTIONAL',
}

export enum CREATE_ENTERPRISE_TYPE {
  marya = 'MARYA',
  parent = 'PARENT',
  child = 'CHILD',
  b2b = 'B2B',
}

export enum UI_CONSOLE_HTTP_METHODS {
  GET = 'GET',
  POST = 'POST',
}

type UpdateOrderFieldConfigField = keyof Enterprise.OrderFieldUpdateConfig;
export const updateOrderFieldSettingsField: UpdateOrderFieldConfigField[] = [
  'isProvidersUpdateDisabled',
  'isVisitsUpdateDisabled',
  'isDeliveryIntervalUpdateDisabled',
  'isDepartmentUpdateDisabled',
  'isBrandUpdateDisabled',
  'isClientNameUpdateDisabled',
  'isClientPhoneUpdateDisabled',
  'isClientEmailUpdateDisabled',
  'isUpdateOrderNumberDisabled',
  'isProvidersUpdateDisabledBeforeFullPayment',
  'isSpecializationUpdateDisabled',
];
